import { genreOptions, yearOptions } from "@/mocks/categories";

interface FilterBarProps {
  genre: string;
  year: string;
  sort: string;
  total: number;
  onGenreChange: (value: string) => void;
  onYearChange: (value: string) => void;
  onSortChange: (value: string) => void;
  onReset: () => void;
}

const sortOptions = [
  { value: "latest", label: "最新" },
  { value: "hot", label: "最热" },
  { value: "rating", label: "评分" },
];

export default function FilterBar({
  genre,
  year,
  sort,
  total,
  onGenreChange,
  onYearChange,
  onSortChange,
  onReset,
}: FilterBarProps) {
  const isFiltered = genre !== "全部" || year !== "all" || sort !== "latest";

  return (
    <div className="rounded-lg border border-background-200/80 bg-background-100/60">
      <div className="flex flex-col gap-3 p-4 md:flex-row md:items-center md:gap-5">
        <span className="shrink-0 font-label text-[11px] uppercase tracking-[0.22em] text-foreground-500">
          影片类型
        </span>
        <div className="no-scrollbar -mx-1 flex gap-2 overflow-x-auto px-1 pb-1">
          {genreOptions.map((option) => (
            <button
              key={option}
              type="button"
              onClick={() => onGenreChange(option)}
              className={`shrink-0 cursor-pointer whitespace-nowrap rounded-md px-3 py-1.5 text-xs transition-colors ${
                genre === option
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-400 hover:text-foreground-900"
              }`}
            >
              {option}
            </button>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-4 border-t border-background-200/70 p-4 md:flex-row md:items-center md:justify-between">
        <div className="flex flex-wrap items-center gap-3">
          <label className="relative flex items-center">
            <span className="sr-only">选择年份</span>
            <i className="ri-calendar-line pointer-events-none absolute left-3 text-sm text-foreground-500"></i>
            <select
              value={year}
              onChange={(e) => onYearChange(e.target.value)}
              className="h-9 cursor-pointer appearance-none rounded-md border border-background-200 bg-background-50 pl-8 pr-8 text-xs text-foreground-700 outline-none transition-colors hover:border-primary-400 focus:border-primary-400"
            >
              {yearOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <i className="ri-arrow-down-s-line pointer-events-none absolute right-2 text-sm text-foreground-500"></i>
          </label>

          <div className="flex items-center gap-1 rounded-md border border-background-200 bg-background-50 p-1">
            {sortOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                onClick={() => onSortChange(option.value)}
                className={`cursor-pointer whitespace-nowrap rounded px-3 py-1 text-xs transition-colors ${
                  sort === option.value
                    ? "bg-secondary-500 text-background-50"
                    : "text-foreground-500 hover:text-foreground-900"
                }`}
              >
                {option.label}
              </button>
            ))}
          </div>

          <span className="text-xs text-foreground-500">
            共 <span className="font-label text-sm font-semibold text-accent-400">{total}</span> 部影片
          </span>
        </div>

        <button
          type="button"
          onClick={onReset}
          disabled={!isFiltered}
          className={`inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md px-3 py-1.5 text-xs transition-colors ${
            isFiltered
              ? "text-foreground-600 hover:text-accent-400"
              : "cursor-not-allowed text-foreground-400"
          }`}
        >
          <i className="ri-refresh-line text-sm"></i>
          重置筛选
        </button>
      </div>
    </div>
  );
}